import React, { Component } from 'react';

const Loading = ({ error, timedOut, pastDelay }) => {
  if (error || timedOut) {
    return (
      <p>
        This question failed to load. We&#39;ve been notified and will fix the
        issue shortly. Please refresh the page and try again.
      </p>
    );
  } else if (pastDelay) {
    return (
      <div className="rounded bc-light_gray" style={{ height: '16rem' }} />
    );
  } else {
    return (
      <div className="rounded bc-light_gray" style={{ height: '16rem' }} />
    );
  };
}

export default Loading;
